import script from "./AddUserToWorkspaceWithGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserToWorkspaceWithGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUserToWorkspaceWithGroupModal.vue?vue&type=style&index=0&id=3c4965e2&lang=scss&scoped=true"
import "./AddUserToWorkspaceWithGroupModal.vue?vue&type=style&index=1&id=3c4965e2&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4965e2"]])

export default __exports__